module.exports = __webpack_public_path__ + "img/tp-11.929c89b4.png";